/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { FlightCompany } from '../../models/flight-company';

export interface CommonControllerDeleteFlightCompany$Params {
  code: string;
}

export function commonControllerDeleteFlightCompany(http: HttpClient, rootUrl: string, params: CommonControllerDeleteFlightCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerDeleteFlightCompany.PATH, 'delete');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: FlightCompany;
      }>;
    })
  );
}

commonControllerDeleteFlightCompany.PATH = '/common/flight-companies/{code}';
